import action from '../commons/queueActionStatus'; 

export const getQueueRequestAction = (date, hospitalId) => {
    return {
        type: action.GET_QUEUE_REQUEST,
        status: 'GET_QUEUE_REQUEST',
        payload: {
            date,
            hospitalId,
        },
        requestState: true,
    };
};

export const getQueueSuccessAction = (result) => {
    return {
        type: action.GET_QUEUE_SUCCESS,
        status: 'Queue retrieved sucessfully',
        result,
        requestState: false,
    };
};

export const getQueueFailureAction = (error) => {
    return {
        type: action.GET_QUEUE_FAILURE,
        status: 'Get Queue failure',
        error,
        requestState: false,
    };
};

export const getSilentQueueRequestAction = (date, hospitalId) => {
    return {
        type: action.GET_SILENT_QUEUE_REQUEST,
        status: 'GET_SILENT_QUEUE_REQUEST',
        payload: {
            date,
            hospitalId,
        },
        requestState: true,
    };
};

export const getSilentQueueSuccessAction = (result) => {
    return {
        type: action.GET_SILENT_QUEUE_SUCCESS,
        status: 'Queue retrieved sucessfully Silent',
        result,
        requestState: false,
    };
};

export const getSilentQueueFailureAction = (error) => {
    return {
        type: action.GET_SILENT_QUEUE_FAILURE,
        status: 'Get Queue failure',
        error,
        requestState: false,
    };
};

export const resetQueueAction = () => {
    return {
        type: action.RESET_QUEUE_STATE
    };
};


